/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.MeetingTemplateSectionTopicLink = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The MeetingTemplateSectionTopicLink model module.
   * @module model/MeetingTemplateSectionTopicLink
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>MeetingTemplateSectionTopicLink</code>.
   * @alias module:model/MeetingTemplateSectionTopicLink
   * @class
   */
  var exports = function() {
    var _this = this;







  };

  /**
   * Constructs a <code>MeetingTemplateSectionTopicLink</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MeetingTemplateSectionTopicLink} obj Optional instance to populate.
   * @return {module:model/MeetingTemplateSectionTopicLink} The populated <code>MeetingTemplateSectionTopicLink</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('SectionTopicID')) {
        obj['SectionTopicID'] = ApiClient.convertToType(data['SectionTopicID'], 'Integer');
      }
      if (data.hasOwnProperty('ContentTypeID')) {
        obj['ContentTypeID'] = ApiClient.convertToType(data['ContentTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('ContentID')) {
        obj['ContentID'] = ApiClient.convertToType(data['ContentID'], 'Integer');
      }
      if (data.hasOwnProperty('ForwardText')) {
        obj['ForwardText'] = ApiClient.convertToType(data['ForwardText'], 'String');
      }
      if (data.hasOwnProperty('EmbeddedToMeetingSectionTopic')) {
        obj['EmbeddedToMeetingSectionTopic'] = ApiClient.convertToType(data['EmbeddedToMeetingSectionTopic'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} SectionTopicID
   * @default 0
   */
  exports.prototype['SectionTopicID'] = 0;
  /**
   * @member {Integer} ContentTypeID
   * @default 0
   */
  exports.prototype['ContentTypeID'] = 0;
  /**
   * @member {Integer} ContentID
   * @default 0
   */
  exports.prototype['ContentID'] = 0;
  /**
   * @member {String} ForwardText
   * @default ''
   */
  exports.prototype['ForwardText'] = '';
  /**
   * @member {Boolean} EmbeddedToMeetingSectionTopic
   * @default false
   */
  exports.prototype['EmbeddedToMeetingSectionTopic'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


